import { Link } from "react-router-dom";
import { PROJECT_GROUPS, projectsInGroup } from "../../lib/projects";

/**
 * Site footer in the spirit of a turn-of-the-century personal homepage: link
 * columns, a network of related sites, a (decorative) hit counter, the
 * obligatory browser-compatibility brag, and a copyright line.
 */

/** A stable, decorative visitor number — not a real counter. */
const VISITOR_NO = 0o0_125_312; // octal flourish; renders as 42698

const YOUTUBE = "https://www.youtube.com/@CaseyScottMckay";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <h4>C.S. McKay</h4>
          <p className="mono" style={{ margin: 0, lineHeight: 1.6 }}>
            A personal website with posts, photos, videos, and more.
          </p>
        </div>

        <div>
          <h4>Browse</h4>
          <p className="stack" style={{ gap: "0.25rem", margin: 0 }}>
            <Link to="/photos">» Photos</Link>
            <Link to="/videos">» Videos</Link>
            <Link to="/blog">» Blog</Link>
            <Link to="/search">» Search</Link>
            <a href={YOUTUBE} target="_blank" rel="noopener noreferrer">
              » YouTube ↗
            </a>
          </p>
        </div>

        <div>
          <h4>This Site</h4>
          <p className="stack" style={{ gap: "0.25rem", margin: 0 }}>
            <Link to="/about">» About</Link>
            <Link to="/projects">» Projects &amp; Partners</Link>
            <Link to="/cv">» CV / Résumé</Link>
            <Link to="/contact">» Contact / sign the book</Link>
            <Link to="/admin">» Admin</Link>
          </p>
        </div>
      </div>

      <div className="footer-network">
        <h4>
          The Network <Link to="/projects">— all projects &amp; partners →</Link>
        </h4>
        <div className="footer-network__groups">
          {PROJECT_GROUPS.map((group) => (
            <div key={group.id}>
              <p className="footer-network__label">{group.label}</p>
              <p className="stack" style={{ gap: "0.25rem", margin: 0 }}>
                {projectsInGroup(group.id).map((project) =>
                  project.current ? (
                    <Link key={project.id} to="/">
                      » {project.short}
                    </Link>
                  ) : (
                    <a
                      key={project.id}
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      » {project.short} ↗
                    </a>
                  ),
                )}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="footer-meta">
        <p style={{ margin: "0 0 0.4rem" }}>
          You are visitor{" "}
          <span className="hit-counter">{String(VISITOR_NO).padStart(6, "0")}</span> · Last
          updated {year} · Best viewed in Netscape Navigator 4.0 @ 800×600
        </p>
        <p style={{ margin: 0 }}>© {year} Casey Scott McKay. All rights reserved.</p>

        <div className="badges" aria-hidden="true">
          <span className="badge badge--blue">Netscape Now!</span>
          <span className="badge">HTML 3.2</span>
          <span className="badge badge--silver">Made on a Mac</span>
          <span className="badge">800×600</span>
          <span className="badge badge--blue">Y2K Ready</span>
        </div>
      </div>
    </footer>
  );
}
